// This file was generated by a custom prisma generator, do not edit manually.
export const CandidateStatusEnumValue = {
  prospecting: 'PROSPECTING',
  quizSent: 'QUIZSENT',
  quizTaken: 'QUIZTAKEN',
  pending: 'PENDING',
  blacklist: 'BLACKLIST',
  shortlist: 'SHORTLIST',
} as const;

export type CandidateStatusEnumValue = (typeof CandidateStatusEnumValue)[keyof typeof CandidateStatusEnumValue];

export const CollaboratorAccessEnumValue = {
  view: 'VIEW',
  edit: 'EDIT',
} as const;

export type CollaboratorAccessEnumValue = (typeof CollaboratorAccessEnumValue)[keyof typeof CollaboratorAccessEnumValue];

export const CollaboratorRolesEnumValue = {
  editor: 'EDITOR',
  reviewer: 'REVIEWER',
  approver: 'APPROVER',
} as const;

export type CollaboratorRolesEnumValue = (typeof CollaboratorRolesEnumValue)[keyof typeof CollaboratorRolesEnumValue];

export const DetailValueTypeEnumValue = {
  oneline: 'ONELINE',
  multiline: 'MULTILINE',
  checkbox: 'CHECKBOX',
  radiobutton: 'RADIOBUTTON',
} as const;

export type DetailValueTypeEnumValue = (typeof DetailValueTypeEnumValue)[keyof typeof DetailValueTypeEnumValue];

export const EmailStatusEnumValue = {
  pending: 'PENDING',
  sent: 'SENT',
  delivered: 'DELIVERED',
  delayed: 'DELAYED',
  opened: 'OPENED',
  clicked: 'CLICKED',
  bounced: 'BOUNCED',
  complained: 'COMPLAINED',
} as const;

export type EmailStatusEnumValue = (typeof EmailStatusEnumValue)[keyof typeof EmailStatusEnumValue];

export const JobSkillTypeEnumValue = {
  technical: 'TECHNICAL',
  cognitive: 'COGNITIVE',
} as const;

export type JobSkillTypeEnumValue = (typeof JobSkillTypeEnumValue)[keyof typeof JobSkillTypeEnumValue];

export const JobPriorityEnumValue = {
  high: 'HIGH',
  medium: 'MEDIUM',
  low: 'LOW',
} as const;

export type JobPriorityEnumValue = (typeof JobPriorityEnumValue)[keyof typeof JobPriorityEnumValue];

export const JobStatusEnumValue = {
  draft: 'DRAFT',
  approved: 'APPROVED',
  active: 'ACTIVE',
  end: 'END',
  cancelled: 'CANCELLED',
} as const;

export type JobStatusEnumValue = (typeof JobStatusEnumValue)[keyof typeof JobStatusEnumValue];

export const QuestionTypeEnumValue = {
  mcq: 'MCQ',
  mcqRankOption: 'MCQRANKOPTION',
} as const;

export type QuestionTypeEnumValue = (typeof QuestionTypeEnumValue)[keyof typeof QuestionTypeEnumValue];

export const TemplateTypeEnumValue = {
  email: 'EMAIL',
  jd: 'JD',
} as const;

export type TemplateTypeEnumValue = (typeof TemplateTypeEnumValue)[keyof typeof TemplateTypeEnumValue];

export const WebhookReceiverEnumValue = {
  user: 'USER',
  zapier: 'ZAPIER',
  make: 'MAKE',
  slack: 'SLACK',
  segment: 'SEGMENT',
} as const;

export type WebhookReceiverEnumValue = (typeof WebhookReceiverEnumValue)[keyof typeof WebhookReceiverEnumValue];

export const FolderAccessLevelEnumValue = {
  read: 'READ',
  write: 'WRITE',
} as const;

export type FolderAccessLevelEnumValue = (typeof FolderAccessLevelEnumValue)[keyof typeof FolderAccessLevelEnumValue];

export const FolderUserRoleEnumValue = {
  owner: 'OWNER',
  editor: 'EDITOR',
  viewer: 'VIEWER',
} as const;

export type FolderUserRoleEnumValue = (typeof FolderUserRoleEnumValue)[keyof typeof FolderUserRoleEnumValue];

export const FolderTypeEnumValue = {
  default: 'DEFAULT',
  collection: 'COLLECTION',
} as const;

export type FolderTypeEnumValue = (typeof FolderTypeEnumValue)[keyof typeof FolderTypeEnumValue];

export const ProfessionalPlatformEnumValue = {
  linkedIn: 'LINKEDIN',
  github: 'GITHUB',
  leetcode: 'LEETCODE',
  other: 'OTHER',
} as const;

export type ProfessionalPlatformEnumValue = (typeof ProfessionalPlatformEnumValue)[keyof typeof ProfessionalPlatformEnumValue];

export const ProductivityToolEnumValue = {
  leetcode: 'LEETCODE',
  hackerRank: 'HACKERRANK',
  codechef: 'CODECHEF',
  other: 'OTHER',
} as const;

export type ProductivityToolEnumValue = (typeof ProductivityToolEnumValue)[keyof typeof ProductivityToolEnumValue];

export const LanguageProficiencyEnumValue = {
  native: 'NATIVE',
  fluent: 'FLUENT',
  intermediate: 'INTERMEDIATE',
  basic: 'BASIC',
} as const;

export type LanguageProficiencyEnumValue = (typeof LanguageProficiencyEnumValue)[keyof typeof LanguageProficiencyEnumValue];

export const NationalIdentifierEnumValue = {
  passport: 'PASSPORT',
  nationalId: 'NATIONALID',
  drivingLicense: 'DRIVINGLICENSE',
  other: 'OTHER',
} as const;

export type NationalIdentifierEnumValue = (typeof NationalIdentifierEnumValue)[keyof typeof NationalIdentifierEnumValue];

export const QuizStatusEnumValue = {
  clicked: 'CLICKED',
  login: 'LOGIN',
  inprogress: 'INPROGRESS',
  completed: 'COMPLETED',
  expired: 'EXPIRED',
} as const;

export type QuizStatusEnumValue = (typeof QuizStatusEnumValue)[keyof typeof QuizStatusEnumValue];

export const TaxonomyTagsEnumValue = {
  comprehension: 'COMPREHENSION',
  application: 'APPLICATION',
  analysis: 'ANALYSIS',
  synthesis: 'SYNTHESIS',
  evaluation: 'EVALUATION',
} as const;

export type TaxonomyTagsEnumValue = (typeof TaxonomyTagsEnumValue)[keyof typeof TaxonomyTagsEnumValue];

export const UserRolesEnumValue = {
  owner: 'OWNER',
  member: 'MEMBER',
} as const;

export type UserRolesEnumValue = (typeof UserRolesEnumValue)[keyof typeof UserRolesEnumValue];

export const WorkspacePlansEnumValue = {
  kickstart: 'KICKSTART',
  pro: 'PRO',
  business: 'BUSINESS',
  enterprise: 'ENTERPRISE',
} as const;

export type WorkspacePlansEnumValue = (typeof WorkspacePlansEnumValue)[keyof typeof WorkspacePlansEnumValue];

export const PricingPlanIntervalEnumValue = {
  day: 'DAY',
  week: 'WEEK',
  month: 'MONTH',
  year: 'YEAR',
} as const;

export type PricingPlanIntervalEnumValue = (typeof PricingPlanIntervalEnumValue)[keyof typeof PricingPlanIntervalEnumValue];

export const PricingTypeEnumValue = {
  oneTime: 'ONETIME',
  recurring: 'RECURRING',
} as const;

export type PricingTypeEnumValue = (typeof PricingTypeEnumValue)[keyof typeof PricingTypeEnumValue];

export const SubscriptionStatusEnumValue = {
  trialing: 'TRIALING',
  active: 'ACTIVE',
  canceled: 'CANCELED',
  incomplete: 'INCOMPLETE',
  incompleteExpired: 'INCOMPLETEEXPIRED',
  pastDue: 'PASTDUE',
  unpaid: 'UNPAID',
} as const;

export type SubscriptionStatusEnumValue = (typeof SubscriptionStatusEnumValue)[keyof typeof SubscriptionStatusEnumValue];

export const PayoutStatusEnumValue = {
  pending: 'PENDING',
  processing: 'PROCESSING',
  completed: 'COMPLETED',
  failed: 'FAILED',
} as const;

export type PayoutStatusEnumValue = (typeof PayoutStatusEnumValue)[keyof typeof PayoutStatusEnumValue];

export const PayoutTypeEnumValue = {
  leads: 'LEADS',
  sales: 'SALES',
  clicks: 'CLICKS',
  custom: 'CUSTOM',
} as const;

export type PayoutTypeEnumValue = (typeof PayoutTypeEnumValue)[keyof typeof PayoutTypeEnumValue];

export const ProgramTypeEnumValue = {
  affiliate: 'AFFILIATE',
  referral: 'REFERRAL',
} as const;

export type ProgramTypeEnumValue = (typeof ProgramTypeEnumValue)[keyof typeof ProgramTypeEnumValue];

export const CommissionTypeEnumValue = {
  percentage: 'PERCENTAGE',
  flat: 'FLAT',
} as const;

export type CommissionTypeEnumValue = (typeof CommissionTypeEnumValue)[keyof typeof CommissionTypeEnumValue];

export const ProgramEnrollmentStatusEnumValue = {
  approved: 'APPROVED',
  pending: 'PENDING',
  rejected: 'REJECTED',
  banned: 'BANNED',
  invited: 'INVITED',
  declined: 'DECLINED',
} as const;

export type ProgramEnrollmentStatusEnumValue = (typeof ProgramEnrollmentStatusEnumValue)[keyof typeof ProgramEnrollmentStatusEnumValue];

export const CommissionIntervalEnumValue = {
  month: 'MONTH',
  year: 'YEAR',
} as const;

export type CommissionIntervalEnumValue = (typeof CommissionIntervalEnumValue)[keyof typeof CommissionIntervalEnumValue];

export const ProgramResourceTypeEnumValue = {
  logo: 'LOGO',
  files: 'FILES',
} as const;

export type ProgramResourceTypeEnumValue = (typeof ProgramResourceTypeEnumValue)[keyof typeof ProgramResourceTypeEnumValue];

export const PartnerStatusEnumValue = {
  default: 'DEFAULT',
  verified: 'VERIFIED',
  featured: 'FEATURED',
} as const;

export type PartnerStatusEnumValue = (typeof PartnerStatusEnumValue)[keyof typeof PartnerStatusEnumValue];

export const PartnerRoleEnumValue = {
  owner: 'OWNER',
  member: 'MEMBER',
} as const;

export type PartnerRoleEnumValue = (typeof PartnerRoleEnumValue)[keyof typeof PartnerRoleEnumValue];

export const InvoiceStatusEnumValue = {
  processing: 'PROCESSING',
  completed: 'COMPLETED',
  failed: 'FAILED',
} as const;

export type InvoiceStatusEnumValue = (typeof InvoiceStatusEnumValue)[keyof typeof InvoiceStatusEnumValue];

export const SaleStatusEnumValue = {
  pending: 'PENDING',
  processed: 'PROCESSED',
  paid: 'PAID',
  refunded: 'REFUNDED',
  duplicate: 'DUPLICATE',
  fraud: 'FRAUD',
} as const;

export type SaleStatusEnumValue = (typeof SaleStatusEnumValue)[keyof typeof SaleStatusEnumValue];

export const CommissionStatusEnumValue = {
  pending: 'PENDING',
  processed: 'PROCESSED',
  paid: 'PAID',
  refunded: 'REFUNDED',
  duplicate: 'DUPLICATE',
  fraud: 'FRAUD',
} as const;

export type CommissionStatusEnumValue = (typeof CommissionStatusEnumValue)[keyof typeof CommissionStatusEnumValue];

export const EventTypeEnumValue = {
  click: 'CLICK',
  lead: 'LEAD',
  sale: 'SALE',
} as const;

export type EventTypeEnumValue = (typeof EventTypeEnumValue)[keyof typeof EventTypeEnumValue];

export const PaymentProviderEnumValue = {
  stripe: 'STRIPE',
  chargebee: 'CHARGEBEE',
  razorpay: 'RAZORPAY',
} as const;

export type PaymentProviderEnumValue = (typeof PaymentProviderEnumValue)[keyof typeof PaymentProviderEnumValue];

export const PartnerProfileTypeEnumValue = {
  individual: 'INDIVIDUAL',
  company: 'COMPANY',
} as const;

export type PartnerProfileTypeEnumValue = (typeof PartnerProfileTypeEnumValue)[keyof typeof PartnerProfileTypeEnumValue];
